import { SearchSettings } from '../types';

/**
 * Create a query string from a search object. For use when interacting with Givebacks APIs
 * @param settings - The search object
 * @returns An object with the query string and the search params
 */
const createSearchQuery = <T extends SearchSettings>(settings?: T) => {
  const searchQueryParams = new URLSearchParams();

  if (!settings) return { queryString: '', searchParams: searchQueryParams };

  if (settings.order) {
    searchQueryParams.set(`order[${settings.order.field}]`, settings.order.direction);
  }

  if (settings.searches) {
    Object.entries(settings.searches).forEach((search) => {
      if (!search[1]) return;
      /** Search field name would be the field name */
      const searchFieldName = search[0];

      Object.entries(search[1]).forEach((value) => {
        /** Search key would be the search type (value, by) */
        /** Search value would be the search value */
        const [searchKey, searchValue] = value;
        /** If the search value is not undefined, add it to the query string */
        if (searchValue !== undefined && String(searchValue).length > 0) {
          searchQueryParams.append(`search[${searchFieldName}][${searchKey}]`, String(searchValue));
        }
      });
    });
  }

  if (settings.options) {
    Object.entries(settings.options).forEach((option) => {
      const [optionKey, optionValue] = option;
      searchQueryParams.append(optionKey, String(optionValue));
    });
  }

  if (settings.join) {
    searchQueryParams.append('join', settings.join);
  }

  return {
    queryString: searchQueryParams.toString(),
    searchParams: searchQueryParams,
  };
};

export { createSearchQuery };
